import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA, 
  MatDialogRef
} from '@angular/material/dialog';
import { CommonModule, Location } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { UserService } from 'src/app/home/services/user.service';
import { timestampFormat } from '../../../app/config/moment';
import { EditUserComponent } from '../edit-user/edit-user.component';

@Component({
  selector: 'app-user-detail',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss', '../../app.component.scss', '../../shared/base-modal.style.scss']
})
export class UserDetailComponent {
  public timestampFormat = timestampFormat;
  public dialogData: any;

  public userDetails: any;

  constructor(
    public userService: UserService,
    public dialogRef: MatDialogRef<UserDetailComponent>,
    public dialog: MatDialog,
    public location: Location,
    public router: Router,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    this.getUserDetails();
  }

  getUserDetails(){
    this.userService.getUserDetails(this.dialogData.userId, 1).subscribe((res)=>{
      if (res.data) {
        this.userDetails = res.data;
      }
    });
  }

  editUserDialog(): void {
    const dialogRef = this.dialog.open(EditUserComponent, {
      data: {
        userId: this.userDetails.user_id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getUserDetails();
      }
    });
  }

  navigateToRole(roleId: string|number){
    this.dialogRef.close();
    this.router.navigateByUrl(`roles?id=${roleId}`)
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
